<template>
    <RecommendedItem v-if="mostPopularCourses.length > 0" :title="$t('LandingPage.recommended_items_most_popular_courses_title')">
        <CarouselCourses theme="dark" :courses="mostPopularCourses" />
    </RecommendedItem>
</template>

<script>
    import { mapGetters } from 'vuex'
    import RecommendedItem from 'components/landingpage/RecommendedItem'
    import CarouselCourses from 'components/user/summary/carousel/CarouselCourses'
    import withLanguage from 'components/landingpage/recommended-items/mixins/with-language'

    export default {
        components: { CarouselCourses, RecommendedItem },
        computed: {
            ...mapGetters({
                mostPopularCourses: 'Courses/getMostPopularCourses'
            })
        }
    }
</script>
